import ReservationService from '~/services/ReservationService';

import { reservationQueryKeys } from './reservationQueryKeys';
import { RoomRateInfo, useGroupedByRoomRate } from './useGroupedByRoomRate';

export function useGetBlackoutDatesByRoomRate(
  propertyId: string,
  selectedRoomRates: Array<RoomRateInfo>,
  enabled: boolean,
) {
  return useGroupedByRoomRate<App.BlackoutDate>(
    reservationQueryKeys.blackoutDatesByRoomRate(
      propertyId,
      selectedRoomRates.map((rr) => rr.roomRate.id),
    ),
    propertyId,
    selectedRoomRates,
    enabled,
    async (property, roomType, roomRate) => {
      const blackoutDatesResponse = await ReservationService.getBlackoutDates(property, roomType, roomRate);
      return blackoutDatesResponse.result?.dates ?? [];
    },
  );
}
